import React, { PureComponent } from 'react';
import { Treemap, ResponsiveContainer, Tooltip, Cell } from 'recharts';
import theme from '../../theme';

const CustomizedContent = ({ root, depth, x, y, width, height, index, payload, rank, name, colors }) => {
  return (
    <>
      <rect
        x={x}
        y={y}
        width={width}
        height={height}
        style={{
          // fill: colors[Math.floor((index / root.children.length) * 6)],
          fill: colors[name],
          stroke: '#fff',
          strokeWidth: 2 / (depth + 1e-10),
          strokeOpacity: 1 / (depth + 1e-10),
        }}
      />
      {depth === 2 ? (
        <text
          x={x + width / 2}
          y={y + height / 2 + 7}
          textAnchor="middle"
          fill="#fff"
          fontSize={12}
          fontWeight={300}
        >
          {name}
        </text>
      ) : null}
    </>
  )
}

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    return (
      <div
        style={{
          backgroundColor: '#fff',
          border: `1px solid ${theme.palette.grey.w200}`,
          padding: '5px'
        }}
      >
        <p>{payload[0].payload.name} : {payload[0].payload.size}</p>
      </div>
    );
  }

  return null;
}


const TreeMapCustom = ({ chartData, settings, colors }) => {
  return (
    <ResponsiveContainer width="100%" height={230}>
      <Treemap
        width="100%"
        height={200}
        data={chartData}
        dataKey="size"
        stroke="#fff"
        fill="#fff"
        isAnimationActive={false}
        content={<CustomizedContent colors={colors} />}
      >
        <Tooltip content={<CustomTooltip />} />
        <Cell />
      </Treemap>
    </ResponsiveContainer>
  );
}

export default TreeMapCustom;